<app-breadcrumb  [master]="'Narzędzia'" [parentName]="'Baza wiedzy'" [name]="'Tagi'"></app-breadcrumb>
<div class="tag-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="tag-list-filters">

  </form>
  <div >
    <div class="add-button">
        <button  (click)="add()"  mat-raised-button color="accent" [disabled]="!(userPermissions | async).file_manager.create">
          <mat-icon>add</mat-icon> <span> Dodaj</span>
        </button>
    </div>


  </div>

  <table mat-table [dataSource]="tags" multiTemplateDataRows  >
    <!-- Position Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef >  Nazwa tagu</th>
      <td mat-cell *matCellDef="let element">
       {{element.name}}
      </td>
    </ng-container>


    <ng-container matColumnDef="active">
      <th mat-header-cell *matHeaderCellDef  > Aktywny</th>
      <td mat-cell *matCellDef="let element" >
        {{ element.active ? 'TAK' : 'NIE' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="createAt">
      <th mat-header-cell *matHeaderCellDef > Data dodania</th>
      <td mat-cell *matCellDef="let element" >
        {{element.createdAt | date:'y-MM-dd'}}
      </td>
    </ng-container>


    <ng-container matColumnDef="createdBy">
      <th mat-header-cell *matHeaderCellDef > Użytkownik</th>
      <td mat-cell *matCellDef="let element" >
        {{element.createdBy }}
      </td>
    </ng-container>

    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef > </th>
      <td mat-cell *matCellDef="let element" >
        <button  mat-icon-button
                 [disabled]="!(userPermissions | async).file_manager.write"
                (click)="mod(element)">
          <mat-icon>edit</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
